import React from 'react';
import { ShieldCheck } from 'lucide-react';
export function Guarantee() {
  return <section className="bg-cream py-16 px-4 border-y-4 border-navy" data-id="element-81">
      <div className="max-w-3xl mx-auto text-center" data-id="element-82">
        <ShieldCheck className="w-20 h-20 md:w-24 md:h-24 text-green mx-auto mb-6" data-id="element-83" />
        <h2 className="text-3xl md:text-5xl font-heading font-black text-white mb-6" data-id="element-84">
          🛡️ TOTAL GUARANTEE — 7 DAYS
        </h2>
        <div className="space-y-4 text-lg md:text-xl text-ink/90 mb-8 font-medium" data-id="element-85">
          <p data-id="element-86">
            Download everything. Print the activities. Try them with your child.
            If for any reason you feel that Kit The Focused Mindset™ doesn't
            improve your child's focus or doesn't make your evenings easier — we
            refund you 100%. No questions asked. Send us an email and we refund
            you down to the last cent.
          </p>
        </div>
        <div className="inline-block bg-lightgray text-white px-6 py-3 rounded-full font-bold shadow-sm border border-border" data-id="element-87">
          <p data-id="element-88">
            The confidence we have in this system is what lets us offer you
            this.
          </p>
        </div>
      </div>
    </section>;
}